import { useTranslation } from 'react-i18next';
import React from 'react';
import {
  FieldValues,
  Control,
  Controller,
  useWatch,
  useFormState,
  UseFormSetValue,
} from 'react-hook-form';
import cx from 'clsx';

import { Input, Checkbox } from '@/components';

import { CommonFields } from './CommonFields';
import style from './index.module.scss';

const max = 100;

export const CustomPrize = ({
  control,
  disabled,
  setValue,
  hiddenEligibilityFields,
}: {
  control: Control<FieldValues, object>;
  disabled: boolean;
  setValue: UseFormSetValue<any>;
  hiddenEligibilityFields?: string[];
}) => {
  const { t } = useTranslation();

  const { errors } = useFormState({ control });

  const [prize_custom, prize_custom_distribution] = useWatch({
    control,
    name: ['prize_custom', 'prize_custom_distribution'],
  });

  return (
    <>
      <div className={style.prizeFormRow}>
        <div>
          <div className={style.title}>{t('LuckyDraw_CustomPrize.1a2ktu')}</div>
          {/* @ts-ignore */}
          <Controller
            name="prize_custom"
            control={control}
            rules={{
              required: true,
              pattern: {
                value: /^[_\-'".\da-zA-Z ]*$/,
                message: t('LuckyDraw_CustomPrize.1b484q3'),
              },
            }}
            render={({ field, fieldState }) => (
              // @ts-ignore
              <Input
                className={cx(style.prizeValue, style.prizeCustomName)}
                {...field}
                maxLength={24}
                disabled={disabled}
              />
            )}
          />
          <div className={cx(style.fieldDesc, errors.prize_custom?.message && style.isError)}>
            <span>{errors.prize_custom?.message || t('LuckyDraw_CustomPrize.xvkmvy')}</span>
            <span className={style.fieldDescCount}>{prize_custom?.length || 0}/24</span>
          </div>
        </div>
        <div className={style.prizeSymbol}>×</div>
        <div>
          <div className={style.title}>{t('LuckyDraw_CustomPrize.110xvcp')}</div>
          {/* @ts-ignore */}
          <Controller
            name="prize_count"
            control={control}
            rules={{
              required: true,
              min: 1,
              max: { value: max, message: t('LuckyDraw_CustomPrize.1smsh6', { amount: max }) },
              pattern: {
                value: /^\d+$/,
                message: t('LuckyDraw_CustomPrize.1jffb0s'),
              },
            }}
            render={({ field, fieldState }) => (
              // @ts-ignore

              <Input
                className={cx(style.prizeValue, style.prizeCustomCount)}
                type="number"
                {...field}
                maxLength={7}
                disabled={disabled}
              />
            )}
          />
          <div className={cx(style.fieldDesc, errors.prize_count?.message && style.isError)}>
            {errors.prize_count?.message || t('LuckyDraw_CustomPrize.hlm5ab')}
          </div>
        </div>
      </div>
      <div className={style.prizeFormRow}>
        <div>
          <div className={style.title}>{t('LuckyDraw_CustomPrize.s9vokc')}</div>
          {/* @ts-ignore */}
          <Controller
            name="prize_custom_distribution"
            control={control}
            rules={{ required: true }}
            render={({ field, fieldState }) => (
              // @ts-ignore
              <Input
                className={cx(style.prizeValue, style.distributInput)}
                {...field}
                maxLength={80}
                disabled={disabled}
              />
            )}
          />
          <div className={style.fieldDesc}>
            <span>{t('LuckyDraw_CustomPrize.63tb6u')}</span>
            <span className={style.fieldDescCount}>
              {prize_custom_distribution?.length || 0}/80
            </span>
          </div>
        </div>
      </div>
      <CommonFields
        control={control}
        disabled={disabled}
        setValue={setValue}
        hiddenEligibilityFields={hiddenEligibilityFields}
      />
      <div className={style.drawTip}>{t('LuckyDraw_CustomPrize.drawTip')}</div>
      <div className={style.drawGuarantee}>
        {/* @ts-ignore */}
        <Controller
          name="_guarantee"
          control={control}
          rules={{ required: true }}
          render={({ field, fieldState }) => (
            <Checkbox
              onChange={field.onChange}
              checked={field.value}
              className={style.checkbox}
              disabled={disabled}>
              <div className={style.checkboxText}>{t('LuckyDraw_CustomPrize.a3dq0e')}</div>
            </Checkbox>
          )}
        />
      </div>
    </>
  );
};
